import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './white_box.less'

class WhiteBox extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  }

  render() {
    return <div styleName="white-box">{this.props.children}</div>
  }
}

export default cssModules(WhiteBox, styles)
